<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <gg-btn
        dark

        tile
        color="primary"
        class="mt-1"
        v-bind="attrs"
        v-on="on"
      >
        Add a new account
      </gg-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in groupLinks"
        :key="index"
        style="cursor: pointer"
      >
        <v-list-item-title @click="followLink(item.href)">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AddNewAccount',
  data () {
    return {
      groupLinks: [
        {
          title: 'Shared Hosting',
          href: 'https://www.greengeeks.com/shared-hosting'
        },
        {
          title: 'Reseller Hosting',
          href: 'https://www.greengeeks.com/reseller-hosting'
        },
        {
          title: 'Virtual Private Server',
          href: 'https://www.greengeeks.com/vps-hosting'
        },
      ]
    }
  },
  methods: {
    followLink (href = '') {
      if (href !== '') {
        window.open(href, '_self')
      }
    }
  }
}
</script>
